import { ReactNode } from 'react';

import { LottieWaveDotLoader } from './LottieWaveDotLoader';

interface Props {
	children?: ReactNode;
}

export default function LoadingWave({ children }: Props) {
	return (
		<div className="cart-loading__container">
			<LottieWaveDotLoader />
			<div className="loader-container">
				<div className="loading-text dots">{children}</div>
			</div>
		</div>
	);
}
